module.exports = __webpack_public_path__ + "img/sparks-yellow-large.9dee81af.png";